import { Navigate, Outlet } from "react-router-dom"
import { GetAuth } from "../context/auth/authProvider"
import { useEffect, useState } from "react";
import { auth } from "../services/firebase";

const PrivateRoute = () => {
    const authState = GetAuth();
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        if(!checked && authState && authState.userAuthenticationVerified !== -1){
            setChecked(true);
        }
    }, [authState.userAuthenticationVerified, checked]);

    if(checked){
        const isFirebaseLoggedIn = auth.currentUser !== null;
        const isLocallyLoggedIn = authState?.currentUser !== null;

        if (!isFirebaseLoggedIn && !isLocallyLoggedIn) {
            return <Navigate to='/login' />
        }

        return <Outlet />
    }
    else{
        return null;
    }
}

export default PrivateRoute;
